export const PENDING = 'PENDING';
export const CANCELED = 'CANCELED';
export const REFUNDED = 'REFUNDED';
export const SUCCESSFUL = 'DONE';

export const WAITING_APPROVE = 'WAITING_APPROVE';
